import { tagName } from "@ember-decorators/component"
// import { mapBy } from "@ember/object/computed"
import Component from "@ember/component"
import { action, set } from "@ember/object"
import styles from "./customize-layout-nav.module.css"

@tagName("")
export default class CustomizeLayoutNav extends Component {
  readonly styles = styles

  args!: {
    lessonsCollapsed: boolean
    classesLinedUp: boolean
    daysAsRows: boolean
    isFilteringClasses: boolean
  }

  isShowingFilterClassesMenu = false

  constraints = [{ to: "window", pin: ["left"] }]

  @action
  toggleFilterClassesMenu() {
    set(this, "isShowingFilterClassesMenu", !this.isShowingFilterClassesMenu)
  }
}
